<template>
    <div v-if="active" class="loading-feedback" :class="{'overlay': overlay}">
        <img v-if="!overlay" src="/images/loading_36.gif" />
        <img v-if="overlay" src="/images/loading_64.gif" />
        <span>{{loadingText}}</span>
    </div>
</template>
<style lang="scss" scoped>

    .loading-feedback {
        color: #666;
        font-weight: bold;

        img, span {
            display: inline-block;
            vertical-align: middle;
        }

        &.overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 100;

            background-color: rgba(white, 0.5);

            text-align: center;

            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;

            span {
                font-size: 26px;
                display: inline-block;
                text-align: center;
            }
        }
    }
</style>
<script>
    export default {

        props: ['active', 'overlay', 'text'],

        data: () => { return {
            loadingText: 'Loading...'
        }},

        mounted: function() {
            if(!this.text) return;
            this.loadingText = this.text;
        }

    }
</script>
